import React, { useState, useEffect } from "react";

import { Box, Card, Grid, Typography, Button, Input, Tooltip, TableContainer, Modal, Table, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme, Divider } from "@mui/material";
import ReportsHeader from "../../../components/ReportHeader";
import dayjs from "dayjs";
import DownloadIcon from '@mui/icons-material/Download';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import 'dayjs/plugin/customParseFormat';
import GlobalConfig from "../../../config/date/GlobalConfig";
import * as XLSX from "xlsx";
import CallAlertBar from '../../../Layout/Alertbar';
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import { Production_API_ENDPOINTS } from "../../../config/api/apiCallProduction";

const ImportQCSpecData = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [selectedStatus, setSelectedStatus] = useState('All');
    const [qcdata, setQcdata] = useState([]);

    const [qcupload, setQcupload] = useState(true);
    const [qcDetailsView, setqcDetailsView] = useState(true);

    const [qcExistingdata, setQcExistingdata] = useState([]);

    const [filters, setFilters] = useState({
        pr_number: '',
        release_no: '',
        // email: '',
        // workphone: '',
        status: '',
        // payales: '',
    });
    const filteredData = qcdata.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const filteredDataExisting = qcExistingdata.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);

                // Specify the cellDates option to handle date formatting
                const workbook = XLSX.read(data, { type: 'array', cellDates: true });

                // Assuming 'StockData' is the first sheet in the Excel file
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Convert sheet data to JSON
                const jsonData = XLSX.utils.sheet_to_json(sheet);

                // Define expected columns
                const expectedColumns = [
                    'Date',
                    'Jumbo No',
                    'Quality',
                    'Order GSM',
                    'Avg GSM',
                    'Caliper (micron)',
                    'Bulk (cc/gm)',
                    'Stiffness MD (mN)',
                    'Stiffness CD (mN)',
                    'Stiffness GM (mN)',
                    'Ratio',
                    'Cobb Top',
                    'Cobb Back',
                    'Plybond (J/m2)',
                    'IGT Dry pick (m/sec)',
                    'Roughness PPS  (um)',
                    'Gloss (%)',
                    'Moisture (%)',
                    'Brightness(%)',
                    'BackBrightness(%)'
                ];

                // Add incremental IDs to each row and validate each field
                const dataWithIds = jsonData.map((row, index) => {
                    // Log the current row for debugging
                    console.log(`Row ${index + 1}:`, row);

                    // Check for missing or empty fields in expected columns
                    const hasEmptyField = expectedColumns.some(col => {
                        const value = row[col];
                        // Log the value being checked
                        console.log(`Checking column "${col}":`, value);

                        return value === undefined || value === null || value === '';
                    });

                    const isValid = !hasEmptyField; // true if no empty fields, false otherwise

                    // Log the validation result for the current row
                    console.log(`Row ${index + 1} isValid:`, isValid);

                    return {
                        id: index + 1,
                        ...row,
                        isValid: isValid // true if no empty fields, false otherwise
                    };
                });

                // Set the data to state
                setQcdata(dataWithIds);
            };

            reader.readAsArrayBuffer(file);
        }
    };



    const downloadExcelFile = () => {
        const excelFilePath = '/excel-templates/QCSpecDataTemplate.xlsx';
        const link = document.createElement('a');
        link.href = excelFilePath;
        link.download = 'QCSpecDataTemplate.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const callApiForSaveQCDetails = async (requestBody) => {
        try {
            const response = await fetch(Production_API_ENDPOINTS.PRODUCTION_SAVE_QC_SPEC_DATA, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });
            if (!response.ok) {
                throw new Error('Unable to update QC data');
            }
            const data = await response.json();
            if (data === 'Quality certificate Specification data successfully imported.') {
                msg('info', 'Info', data);

                setQcdata([]);
            }
            else {
                msg('error', 'Error', data);


            }


        } catch (error) {
            msg('error', 'Error', 'Unable to update QC data');
            throw error; // rethrow the error so that the calling function can handle it
        }
    };



    // Function to prepare data for the API
    const prepareDataForAPI = () => {
        return qcdata
            .filter(row => selectedRows.includes(row.id)) // Only include selected rows
            .map(row => ({
                Date: row.Date instanceof Date
                    ? row.Date.toISOString().slice(0, 10) // Convert to "YYYY-MM-DD"
                    : new Date(row.Date).toISOString().slice(0, 10), // Ensure Date object and format
                JumboNo: row["Jumbo No"],
                Quality: row.Quality,
                OrderGSM: row["Order GSM"],
                AvgGSM: row["Avg GSM"],
                CaliperMicron: row["Caliper (micron)"],
                BulkCcPerGm: row["Bulk (cc/gm)"],
                StiffnessMD: row["Stiffness MD (mN)"],
                StiffnessCD: row["Stiffness CD (mN)"],
                StiffnessGM: row["Stiffness GM (mN)"],
                Ratio: row["Ratio"],
                CobbTop: row["Cobb Top"],
                CobbBack: row["Cobb Back"],
                Plybond: row["Plybond (J/m2)"],
                IGTDryPick: row["IGT Dry pick (m/sec)"],
                RoughnessPPS: row["Roughness PPS  (um)"],
                Gloss: row["Gloss (%)"],
                Moisture: row["Moisture (%)"],
                Brightness: row["Brightness(%)"],
                BackBrightness: row["BackBrightness(%)"],

            }));
    };



    async function SaveQCDetails() {
        const formattedData = prepareDataForAPI();

        if (formattedData.length === 0) {
            // If no valid rows, handle the case (e.g., show a message to the user)


            msg('warning', 'Warning', 'Altease select one valid QC data to import..!');
            return;
        }

        const requestBody = {
            obj: formattedData,
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
        };

        await callApiForSaveQCDetails(requestBody);
    }





    // State to track selected rows
    const [selectedRows, setSelectedRows] = useState([]);

    // Handle Select All Click
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            // Select all valid rows
            const allValidRowIds = filteredData.filter(row => row.isValid).map(row => row.id);
            setSelectedRows(allValidRowIds);
        } else {
            // Deselect all rows
            setSelectedRows([]);
        }
    };

    // Handle Individual Row Selection
    const handleRowCheckboxClick = (event, id) => {
        const selectedIndex = selectedRows.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1)
            );
        }

        setSelectedRows(newSelected);
    };

    // Check if a row is selected
    const isSelected = (id) => selectedRows.indexOf(id) !== -1;

    const [deckleMatchingMsgOpen, setDeckleMatchingMsgOpen] = useState(false);
    const [deckleMatchingSeverityvalue, setDeckleMatchingSeverityvalue] = useState('info');
    const [deckleMatchingMessageValue, setDeckleMatchingMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [deckleMatchingAlertTitleValue, setDeckleMatchingAlertTitleValue] = useState('');

    const msg = (severityvalue, title, messageValue) => {
        setDeckleMatchingSeverityvalue(severityvalue);
        setDeckleMatchingMessageValue(messageValue);
        setDeckleMatchingAlertTitleValue(title);
        setDeckleMatchingMsgOpen(true);
    };


    const getAllQualityCertificateDetails = () => {
        let parameters = {
            p_companyid: 1,

        };

        callApi(API_ENDPOINTS.PRODUCTION_GetALLQualityCertificateDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                const formattedData = data.map(item => ({
                    ...item,
                    date: new Date(item.date).toISOString().split('T')[0] // Extracts the date as 'YYYY-MM-DD'
                }));
                setQcExistingdata(formattedData);


            })
            .catch(error => {
                // // Update state with error message        
                // setReelWeightementSeverityvalue('error');
                // setReelWeightementMessageValue(error.message);
                // setReelWeightementAlertTitleValue('Error');
                // setReelWeightementMsgOpen(true);
            });

    };

    const handleViewQCUpload = () => {
        setQcupload(true);
        setqcDetailsView(false);
    }

    const handleViewQCDetailsView = () => {
        setQcupload(false);
        setqcDetailsView(true);
    }

    useEffect(() => {
        if (qcExistingdata) {
            getAllQualityCertificateDetails();
        }

    }, [qcExistingdata]);

    return (
        <>
            {/* {qcDetailsView && (
                <Box style={{ backgroundColor: "transparent" }}>
                    <Box style={{ backgroundColor: "#0277bd" }} flexDirection={'row'} p={'5px'}>
                        <ReportsHeader title={'Quality Certificate Details'} subtitle="" callback={handleBackWinderMachineEntry} />
                    </Box>
                    <CardContent sx={{ border: "1px solid #3d3d3d" }}>
                        <Box display="flex" flexDirection={'column'}>
                            <Box m='0px' display="flex" justifyContent={'flex-start'}>
                                <Grid container spacing={1} justifyContent="flex-start" style={{ marginTop: '0px' }}>
                                    <Grid item>
                                        <Box display="flex" flexDirection={'row'}>
                                            <Tooltip title="Import QC Data in Excel" >
                                                <IconButton style={{ borderRadius: '8px', }} onClick={handleViewQCUpload}>
                                                    <DownloadIcon style={{ marginRight: '5px', color: '#1e88e5' }} />
                                                    <Typography variant="button" textTransform={'none'} fontSize={13} > Import QC Data</Typography>
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>

                        <Box
                            gridColumn="span 9"
                            gridRow="span 2"
                            alignItems="center"
                            justifyContent="center"
                            // padding={1}
                            sx={{
                                "& .MuiTable-root": {
                                    border: "none",
                                    size: "small",
                                },
                                "& .MuiTableCell-root": {
                                    borderBottom: "none",
                                    border: "1px solid",
                                    borderColor: `${colors.primary[400]} !important`,
                                    padding: "2px",  // Further reduced padding
                                },
                                "& .MuiTableHead-root": {
                                    borderBottom: "none",
                                },
                                "& .MuiTableBody-root": {
                                    overflowY: "auto",
                                },
                                "& .MuiCheckbox-root": {
                                    color: `${colors.blueAccent[200]} !important`,
                                    size: "small",
                                },
                                "& .MuiTableFooter-root": {
                                    borderTop: "none",
                                    backgroundColor: colors.blueAccent[700],
                                    height: "10px",
                                },
                                "& .MuiButton-text": {
                                    color: `${colors.grey[100]} !important`,
                                },
                                // scroll bar
                                maxHeight: {
                                    xs: '72vh', // Extra small devices (phones)
                                    sm: '72vh', // Small devices (tablets)
                                    md: '74vh', // Medium devices (small laptops)
                                    lg: '63vh', // Large devices (desktops)
                                    xl: '80vh', // Extra large devices (large desktops)
                                },

                                overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: colors.primary[400],
                                    borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: colors.blueAccent[600],
                                    borderRadius: '10px',
                                    '&:hover': {
                                        background: colors.blueAccent[800],
                                    },
                                },
                                '&::-webkit-scrollbar-corner': {
                                    background: colors.primary[700],
                                }
                            }}
                        >
                            <TableContainer >
                                <Table stickyHeader size="small" sx={{ tableLayout: 'fixed' }}>
                                    <TableHead sx={{ height: 30 }}>
                                        <TableRow>
                                            <TableCell sx={{width:'130px'}}>PRODUCTION DATE</TableCell>
                                            <TableCell sx={{width:'100px'}}>JUMBO NO</TableCell>
                                            <TableCell sx={{width:'100px'}}>QUALITY</TableCell>
                                            <TableCell sx={{width:'100px'}}>ORDER GSM</TableCell>
                                            <TableCell sx={{width:'100px'}}>AVG GSM</TableCell>
                                            <TableCell sx={{width:'100px'}}>CALPER(micron)</TableCell>
                                            <TableCell sx={{width:'120px'}}>BULK(cc/gm)</TableCell>
                                            <TableCell sx={{width:'120px'}}>STIFFNESS MD(mN)</TableCell>
                                            <TableCell sx={{width:'120px'}}>STIFFNESS CD(mN)</TableCell>
                                            <TableCell sx={{width:'120px'}}>STIFFNESS GM(mN)</TableCell>
                                            <TableCell sx={{width:'100px'}}>RATIO</TableCell>
                                            <TableCell sx={{width:'100px'}}>COBB TOP</TableCell>
                                            <TableCell sx={{width:'100px'}}>COBB BACK</TableCell>
                                            <TableCell sx={{width:'100px'}}>PLYBOND(J/m2)</TableCell>
                                            <TableCell sx={{width:'120px'}}>IGT DRY PICK(m/sec)</TableCell>
                                            <TableCell sx={{width:'120px'}}>ROUGHNESS PPS(um)</TableCell>
                                            <TableCell sx={{width:'100px'}}>GLOSS(%)</TableCell>
                                            <TableCell sx={{width:'100px'}}>MOISTURE(%)</TableCell>
                                            <TableCell sx={{width:'100px'}}>BRIGHTNESS(%)</TableCell>
                                            <TableCell sx={{width:'100px'}}>BACK BRIGHTNESS(%)</TableCell>
                                            <TableCell>
                                                <IconButton >
                                                   
                                                </IconButton>
                                                <Modal
                                                    // open={open}
                                                    // onClose={handleClose}
                                                    aria-labelledby="modal-modal-title"
                                                    aria-describedby="modal-modal-description"
                                                >
                                                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                        <TextField
                                                            label="Parent Roll Number"
                                                            name="name"
                                                            // value={filters.pr_number}
                                                            // onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="MA Number"
                                                            name="companyName"
                                                            // value={filters.release_no}
                                                            //onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />

                                                        <TextField
                                                            label="Status"
                                                            name="status"
                                                            // value={filters.status}
                                                            //onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <Button variant="contained" style={{ marginTop: 10 }}>
                                                         
                                                            Apply Filter
                                                        </Button>
                                                    </Box>
                                                </Modal>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredDataExisting.map((row) => (
                                            <TableRow key={row.id}>
                                                <TableCell>{row.date}</TableCell>
                                                <TableCell>{row.jumbono}</TableCell>
                                                <TableCell>{row.quality}</TableCell>
                                                <TableCell>{row.ordergsm}</TableCell>
                                                <TableCell>{row.avggsm}</TableCell>
                                                <TableCell>{row.calipermicron}</TableCell>
                                                <TableCell>{row.bulkccpergm}</TableCell>
                                                <TableCell>{row.stiffnessmd}</TableCell>
                                                <TableCell>{row.stiffnesscd}</TableCell>
                                                <TableCell>{row.stiffnessgm}</TableCell>
                                                <TableCell>{row.ratio}</TableCell>
                                                <TableCell>{row.cobbtop}</TableCell>
                                                <TableCell>{row.cobbback}</TableCell>
                                                <TableCell>{row.plybond}</TableCell>
                                                <TableCell>{row.igtdrypick}</TableCell>
                                                <TableCell>{row.roughnesspps}</TableCell>
                                                <TableCell>{row.gloss}</TableCell>
                                                <TableCell>{row.moisture}</TableCell>
                                                <TableCell>{row.brightness}</TableCell>
                                                <TableCell>{row.backbrightness}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>

                    </CardContent>

                </Box>

            )} */}

            {qcupload && (
                <Box style={{ backgroundColor: "transparent" }}>
                    <Box flexDirection={'row'} p={'5px'}>
                        <ReportsHeader title={'Import QC Specification Details'} subtitle="" callback={handleBackWinderMachineEntry} />
                    </Box>

                    <CallAlertBar
                        parentRollMsgOpen={deckleMatchingMsgOpen}
                        setParentRollMsgOpen={setDeckleMatchingMsgOpen}
                        parentRollSeverityvalue={deckleMatchingSeverityvalue}
                        setParentRollSeverityvalue={setDeckleMatchingSeverityvalue}
                        parentRollAlertTitleValue={deckleMatchingAlertTitleValue}
                        setParentRollAlertTitleValue={setDeckleMatchingAlertTitleValue}
                        parentRollMessageValue={deckleMatchingMessageValue}
                        setParentRollMessageValue={setDeckleMatchingMessageValue}
                    />

                    <CardContent sx={{ border: "1px solid #3d3d3d" }}>
                        <Box display="flex" flexDirection={'column'}>

                            <Box m='0px' display="flex" justifyContent="flex-start" alignItems="center">
                                <Box display="flex" mr={1} >
                                    <FormControl fullWidth>
                                        <Input
                                            id="file-input"
                                            type="file"
                                            accept=".xlsx, .xls"
                                            onChange={handleFileChange}
                                            sx={{ display: 'none' }}
                                        />
                                        <label htmlFor="file-input" style={{ cursor: "pointer" }}>
                                            <Tooltip title="Select QC Specification Excel File" component="span">
                                                <Box display="flex" alignItems="center">
                                                    <IconButton component="span"> {/* Set `component="span"` to make it work as part of the label */}
                                                        <FileUploadRoundedIcon style={{ color: "#1de9b6" }} />
                                                    </IconButton>
                                                    <Typography align="left" fontSize={13} style={{ cursor: "pointer" }}>
                                                        Select
                                                    </Typography>
                                                </Box>
                                            </Tooltip>
                                        </label>
                                    </FormControl>


                                    <FormControl fullWidth>
                                        <Tooltip title="Save QC Specification Details" onClick={SaveQCDetails}>
                                            <Box display="flex" alignItems="center">
                                                <IconButton>
                                                    <SaveOutlinedIcon style={{ color: "#388e3c" }} />
                                                </IconButton>
                                                <Typography align="left" fontSize={13} style={{ cursor: "pointer" }}>Save</Typography>
                                            </Box>
                                        </Tooltip>
                                    </FormControl>

                                    <FormControl fullWidth>
                                        <Tooltip title="QC Specification Excel Template" onClick={downloadExcelFile}>
                                            <Box display="flex" alignItems="center">
                                                <IconButton>
                                                    <FileDownloadRoundedIcon style={{ color: "#c0ca33" }} />
                                                </IconButton>
                                                <Typography align="left" fontSize={13} style={{ cursor: "pointer" }}>Download</Typography>
                                            </Box>
                                        </Tooltip>
                                    </FormControl>
                                </Box>


                            </Box>
                        </Box>

                        <Box textAlign="right" >
                            <Typography variant="subtitle1" gutterBottom>
                                * Invalid or missing data rows are highlighted in <span style={{ color: 'red' }}>red color</span>.
                            </Typography>
                        </Box>

                        <Divider sx={{ marginTop: '5px', marginBottom: '5px' }} />

                        <Box
                            gridColumn="span 9"
                            gridRow="span 2"
                            alignItems="center"
                            justifyContent="center"

                            sx={{
                                "& .MuiTable-root": {
                                    border: "none",
                                    size: "small",
                                },
                                "& .MuiTableCell-root": {
                                    borderBottom: "none",
                                    border: "1px solid",
                                    borderColor: `${colors.primary[400]} !important`,
                                    padding: "2px",  // Further reduced padding
                                },
                                "& .MuiTableHead-root": {
                                    borderBottom: "none",
                                },
                                "& .MuiTableBody-root": {
                                    overflowY: "auto",
                                },
                                "& .MuiCheckbox-root": {
                                    color: `${colors.blueAccent[200]} !important`,
                                    size: "small",
                                },
                                "& .MuiTableFooter-root": {
                                    borderTop: "none",
                                    backgroundColor: colors.blueAccent[700],
                                    height: "10px",
                                },
                                "& .MuiButton-text": {
                                    color: `${colors.grey[100]} !important`,
                                },

                                maxHeight: {
                                    xs: '72vh', // Extra small devices (phones)
                                    sm: '72vh', // Small devices (tablets)
                                    md: '74vh', // Medium devices (small laptops)
                                    lg: '63vh', // Large devices (desktops)
                                    xl: '80vh', // Extra large devices (large desktops)
                                },
                                overflowX: 'auto',
                                maxWidth: '100%',

                                overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: colors.primary[400],
                                    borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: colors.blueAccent[600],
                                    borderRadius: '10px',
                                    '&:hover': {
                                        background: colors.blueAccent[800],
                                    },
                                },
                                '&::-webkit-scrollbar-corner': {
                                    background: colors.primary[700],
                                }
                            }}
                        >
                            <TableContainer>
                                <Table size="small" >
                                    <TableHead sx={{ height: 10 }}>
                                        <TableRow>
                                            <TableCell>
                                                <Checkbox
                                                    size="small"
                                                    style={{ color: "secondary" }}
                                                    indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.filter(row => row.isValid).length}
                                                    checked={selectedRows.length === filteredData.filter(row => row.isValid).length}
                                                    onChange={handleSelectAllClick}
                                                />
                                            </TableCell>
                                            <TableCell >Date</TableCell>
                                            <TableCell>Jumbo No</TableCell>
                                            <TableCell>Quality</TableCell>
                                            <TableCell>Order GSM</TableCell>
                                            <TableCell>Avg GSM</TableCell>
                                            <TableCell>Caliper (micron)</TableCell>
                                            <TableCell>Bulk (cc/gm)</TableCell>
                                            <TableCell>Stiffness MD (mN)</TableCell>
                                            <TableCell>Stiffness CD (mN)</TableCell>
                                            <TableCell>Stiffness GM (mN)</TableCell>
                                            <TableCell>Ratio</TableCell>
                                            <TableCell>Cobb Top</TableCell>
                                            <TableCell>Cobb Back</TableCell>
                                            <TableCell>Plybond (J/m2)</TableCell>
                                            <TableCell>IGT Dry pick (m/sec)</TableCell>
                                            <TableCell>Roughness PPS (um)</TableCell>
                                            <TableCell>Gloss (%)</TableCell>
                                            <TableCell>Moisture (%)</TableCell>
                                            <TableCell>Brightness (%)</TableCell>
                                            <TableCell>Back Brightness (%)</TableCell>
                                            <TableCell>
                                                <IconButton>
                                                    {/* Add your icon/button here */}
                                                </IconButton>
                                                <Modal
                                                    // open={open}
                                                    // onClose={handleClose}
                                                    aria-labelledby="modal-modal-title"
                                                    aria-describedby="modal-modal-description"
                                                >
                                                    <Box
                                                        sx={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            bgcolor: 'background.paper',
                                                            boxShadow: 24,
                                                            p: 4,
                                                            minWidth: 300
                                                        }}
                                                    >
                                                        <TextField
                                                            label="Parent Roll Number"
                                                            name="name"
                                                            // value={filters.pr_number}
                                                            // onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="MA Number"
                                                            name="companyName"
                                                            // value={filters.release_no}
                                                            // onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="Status"
                                                            name="status"
                                                            // value={filters.status}
                                                            // onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <Button variant="contained" style={{ marginTop: 10 }}>
                                                            {/* onClick={handleClose} */}
                                                            Apply Filter
                                                        </Button>
                                                    </Box>
                                                </Modal>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredData.map((row) => {
                                            const isRowSelected = isSelected(row.id);



                                            const rowStyle = row.isValid
                                                ? {}
                                                : {
                                                    backgroundColor: '#823c3c', // Light background for invalid rows

                                                };
                                            return (
                                                <TableRow key={row.id} style={rowStyle}>
                                                    <TableCell>
                                                        <Checkbox
                                                            size="small"
                                                            checked={isRowSelected}
                                                            onChange={(event) => handleRowCheckboxClick(event, row.id)}
                                                            disabled={!row.isValid} // Disable checkbox if row has empty fields
                                                        />
                                                    </TableCell>

                                                    <TableCell>
                                                        {row.Date
                                                            ? (typeof row.Date === 'object'
                                                                ? row.Date.toLocaleDateString() // Format date if it's a Date object
                                                                : row.Date)
                                                            : '' // Fallback if row.Date is undefined or null
                                                        }
                                                    </TableCell>
                                                    <TableCell>{row["Jumbo No"]}</TableCell>
                                                    <TableCell>{row.Quality}</TableCell>
                                                    <TableCell>{row["Order GSM"]}</TableCell>
                                                    <TableCell>{row["Avg GSM"]}</TableCell>
                                                    <TableCell>{row["Caliper (micron)"]}</TableCell>
                                                    <TableCell>{row["Bulk (cc/gm)"]}</TableCell>
                                                    <TableCell>{row["Stiffness MD (mN)"]}</TableCell>
                                                    <TableCell>{row["Stiffness CD (mN)"]}</TableCell>
                                                    <TableCell>{row["Stiffness GM (mN)"]}</TableCell>
                                                    <TableCell>{row["Ratio"]}</TableCell>
                                                    <TableCell>{row["Cobb Top"]}</TableCell>
                                                    <TableCell>{row["Cobb Back"]}</TableCell>
                                                    <TableCell>{row["Plybond (J/m2)"]}</TableCell>
                                                    <TableCell>{row["IGT Dry pick (m/sec)"]}</TableCell>
                                                    <TableCell>{row["Roughness PPS  (um)"]}</TableCell>
                                                    <TableCell>{row["Gloss (%)"]}</TableCell>
                                                    <TableCell>{row["Moisture (%)"]}</TableCell>
                                                    <TableCell>{row["Brightness(%)"]}</TableCell>
                                                    <TableCell>{row["BackBrightness(%)"]}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Box>

                    </CardContent>

                </Box>
            )}


        </>
    )
};
export default ImportQCSpecData;